import React from 'react';
import { useEffect, useState } from 'react';
import ListingCard from './listingCard';
import ReactPaginate from 'react-paginate';
import AdvertisementCard from './advertisementCard';

const RECORD_PER_PAGE = 9;

const Listing = ({ recordData, advertisement, page }) => {
    console.log('[Listing] [recordData]');
    console.log(recordData);
    const [pagination, setPagination] = useState({
        data: recordData.map((value, index) => ({
            id: index,
            card: value,
        })),
        offset: page * RECORD_PER_PAGE,
        numberPerPage: RECORD_PER_PAGE,
        pageCount: 0,
        currentPage: page,
        currentData: [],
    });
    useEffect(() => {
        console.log('[setPagination]');
        let newData = recordData.map((value, index) => ({
            id: index,
            card: value,
        }));
        let pagecount = Math.ceil(newData.length / pagination.numberPerPage);
        let newoffset = pagination.offset;
        if (pagecount <= pagination.currentPage) {
            newoffset = 0;
        }
        setPagination((prevState) => ({
            ...prevState,
            data: newData,
            offset: newoffset,
            currentPage: Math.ceil(newoffset / pagination.numberPerPage),
            pageCount: Math.ceil(newData.length / prevState.numberPerPage),
            currentData: newData.slice(
                pagination.offset,
                pagination.offset + pagination.numberPerPage
            ),
        }));
    }, [recordData, pagination.numberPerPage, pagination.offset]);
    const handlePageClick = (event) => {
        const selected = event.selected;
        const offset = selected * pagination.numberPerPage;
        console.log('[handlePageClick]' + offset);
        setPagination({ ...pagination, offset });
    };
    return (
        <>
            {pagination.pageCount == 0 ? (
                <>
                    <div className="row mb-3">
                        <div className="col-12">
                            <h5>No new businesses found.</h5>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div class="row mb-3">
                        <div class="col-12">
                            <h5>
                                Showing page {pagination.currentPage + 1} of {pagination.pageCount}.
                            </h5>
                        </div>
                    </div>
                    <div className="row mb-3">
                        {pagination.currentData &&
                            pagination.currentData.map((item, index) => (
                                <ListingCard key={item.id} item={item.card} />
                            ))}
                        <AdvertisementCard item={advertisement} />
                    </div>
                    <ReactPaginate
                        previousLabel={'previous'}
                        nextLabel={'next'}
                        breakLabel={'...'}
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        containerClassName="pagination justify-content-center"
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        activeClassName="active"
                        pageCount={pagination.pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        forcePage={pagination.currentPage}
                        onPageChange={handlePageClick}
                        renderOnZeroPageCount={null}
                    />
                </>
            )}
        </>
    );
};

export default Listing;
